import script from "./TreeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeSelect.vue?vue&type=script&setup=true&lang=js"

import "./TreeSelect.vue?vue&type=style&index=0&id=0150698e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0150698e"]])

export default __exports__